import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'kingaku'
})
export class KingakuPipe implements PipeTransform {

  transform(value: string): string {
    return !value ? '' : Number(value).toLocaleString() + '円';
  }

}
